'use client';
import React from 'react';
import Image from 'next/image';
import styles from '../style.module.scss';
import { IProduct } from '@mybestbrands/types';
import { useTranslation } from 'next-i18next';

interface CouponLabelProps {
  item: IProduct;
  onClick?: () => void;
  blackFridayToggle?: boolean;
}

const CouponLabel = ({ item, onClick, blackFridayToggle }: CouponLabelProps) => {
  const { t } = useTranslation('COMMON');

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // Stop the event from bubbling up to the parent link
    event.preventDefault(); // Prevent the default behavior of any surrounding link
    if (onClick) {
      onClick();
    }
  };

  const getCouponTitle = () => {
    if (item.discountCoupon) {
      return t('COUPON');
    }
    if (item.freeShippingCoupon) {
      return t('SHIPPING_COUPON');
    }
    if (item.newCustomerCoupon) {
      return t('NEW_CUSTOMER_COUPON');
    }
    return;
  };

  const getCouponAmountText = () => {
    if (item.priorityCoupon?.amount) {
      const amount = item.priorityCoupon.amount;
      const amountType = item.priorityCoupon.amount_type;
      return amountType === '%' ? `-${amount}%` : `-${amount?.centsToEuros()}€`;
    }
    return '';
  };

  const couponTitle = getCouponTitle();
  const couponAmountText = getCouponAmountText();

  return (
    <div className={`cursor-pointer`} onClick={handleClick}>
      <span className={styles['couponLabel']} style={{ backgroundColor: blackFridayToggle ? '#000000' : '#EB4E4E' }}>
        {couponAmountText ? `${couponAmountText} ${couponTitle}` : couponTitle}
        <Image
          src="/intstatic/icons/coupon-arrow.svg"
          alt="Coupon"
          style={{ marginLeft: '0.1rem', marginBottom: '0.1rem' }}
          width={10}
          height={9}
        />
      </span>
    </div>
  );
};

export default CouponLabel;
